import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ErrorTypeValidationEnum } from '../../Enums/ErrorTypeValidationEnum';

@Injectable({
  providedIn: 'root'
})
export class InvalidFieldMessageService {
  errorTypeEnum = ErrorTypeValidationEnum;
  constructor(private translateService: TranslateService) { }

  fieldContainsError(control: AbstractControl, errorName: ErrorTypeValidationEnum): boolean {
    if (control && (control.dirty || control.touched)) {
      if (control.hasError(errorName) || (control.errors && control.errors[errorName])) return true;
    }
    return false;
  }

  errorMessage(control: AbstractControl): string {
    // Verificação específica para inscrição estadual personalizada (BA)
    const ieError = control.errors?.['invalid-inscricao-estadual'];
    if (ieError) {
      const uf = ieError.uf;
      const type = ieError.type;
      const translationKey = `stateRegistration.${type}.${uf}`;
      const defaultKey = `stateRegistration.${type}.default`;
      const translated = this.translateService.instant(translationKey);

      // Se a tradução retornada não for igual a chave (ou seja, não existe ainda no pt.json), usar o default
      if (translated === translationKey) {
        return this.translateService.instant(defaultKey);
      }
      return translated;
    } 
    // Validações padrão para outros casos
    else if (control.hasError('invalid') || control.hasError('pattern')) {
      return this.translateService.instant("invalidFieldMessage.invalid");
    } else if (control.hasError('invalid-cpf')) {
      return this.translateService.instant("invalidFieldMessage.invalid-cpf");
    } else if (control.hasError('invalid-cnpj')) {
      const isAlphanumeric = control.errors?.['invalid-cnpj']?.alphanumeric;
      const tipo = isAlphanumeric
        ? this.translateService.instant("invalidFieldMessage.cnpjTypeAlphanumeric")
        : this.translateService.instant("invalidFieldMessage.cnpjTypeNumeric");
      return this.translateService.instant("invalidFieldMessage.invalid-cnpj", { tipo });
    } else if (control.hasError('document-already-used')) {
      return this.translateService.instant("invalidFieldMessage.document-already-used");
    } else if (control.hasError('requiredTaxationRule')) {
      return this.translateService.instant("invalidFieldMessage.requiredTaxationRule");
    } else if (control.hasError('required')) {
      return this.translateService.instant("invalidFieldMessage.required");
    } else if (control.hasError('minlength')) {
      return this.translateService.instant("invalidFieldMessage.minLength", { minLength: control.errors?.['minlength']?.requiredLength });
    } else if (control.hasError('maxlength')) {
      return this.translateService.instant("invalidFieldMessage.maxLength", { maxLength: control.errors?.['maxlength']?.requiredLength });
    } else {
      return control.status == "INVALID" ? this.translateService.instant("invalidFieldMessage.invalid") : "";
    }
  }

  emailInUse(email: string): string {
    return this.translateService.instant("invalidFieldMessage.emailExists", { email: email });
  }

  invalidTaxationField(name: string, value: string) {
    return this.translateService.instant("product.taxationInvalidField", { name: name, value: value });
  }

  endDateMinorThanStartDate() {
    return this.translateService.instant("endDateMinorThanStartDate");
  }

  startDateGreaterThanFinalDate() {
    return this.translateService.instant("startDateGreaterThanFinalDate");
  }

  startDateGreaterThanToday() {
    return this.translateService.instant("startDateGreaterThanToday");
  }

  invalidStateRegistration(uf: string, errors: any): string {
    if (!uf || !errors) return '';

    if (errors['invalid-length']) {
      return this.translateService.instant(`stateRegistration.InvalidFormatInscricaoEstadual.${uf}`);
    }

    if (errors['invalid']) {
      return this.translateService.instant(`stateRegistration.InvalidInscricaoEstadual.${uf}`);
    }

    return this.translateService.instant("invalidFieldMessage.invalid"); 
  }
}